import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const newEmployeesApi = createApi({
  reducerPath: "newEmployeesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    registerEmployee: builder.mutation({
      query: (employeeData) => ({
        url: "/Auth/register",
        method: "POST",
        body: employeeData,
      }),
    }),
    updateEmployee: builder.mutation({
      query: (data) => ({
        url: "/User/update-user",
        method: "POST",
        body: data,
      }),
    }),
    deleteEmployee: builder.mutation({
      query: (id) => ({
        url: `/User/delete-user/${id}`,
        method: "POST",  
      }),
    }),
  }),
});

export const { useRegisterEmployeeMutation, useUpdateEmployeeMutation, useDeleteEmployeeMutation } = newEmployeesApi;
